import { Path } from "@formily/path";
import eventBus from "./eventBus.js";
const defaultName = '';
const eventMap = {};
const cacheEventName = (name, path)=>{
    try {
        const keyname = 'object' == typeof name ? JSON.stringify(name) : name;
        if (path) eventMap[keyname] = path;
        return keyname in eventMap ? eventMap[keyname] : void 0;
    } catch  {
        return;
    }
};
const escapeSpecialSymbols = (text)=>'number' == typeof text ? text : text.replace(/([*~[\],:.])/g, '\\$1');
const defaultLang = Object.freeze({
    customError: 'Does not meet the requirements for custom filtering',
    groupEmpty: 'Do not accept record with group.',
    groupProvider: 'Non group members.',
    tokenEmpty: 'Do not accept record with token.',
    tokenProvider: 'Not providing tokens as expected.'
});
const EventName = 'custom-event-chat';
const combinePath = (name, origin)=>{
    const namepath = getEventName(name, (text)=>text);
    const orgpath = getEventName(origin);
    if (namepath.startsWith('.') || namepath.startsWith('[')) return Path.parse(namepath, orgpath).toString();
    return namepath;
};
const createEvent = (detail)=>new CustomEvent(EventName, {
        bubbles: true,
        cancelable: true,
        detail
    });
const createToken = (key)=>window.btoa(`${key}:${Math.random()}:${Date.now()}`);
const getConditionKey = (name, id, type)=>[
        name,
        id,
        type
    ].filter(Boolean).join('-');
const getEventName = (name, filter)=>{
    const cachePath = cacheEventName(name);
    if (cachePath) return cachePath;
    const eventName = (Array.isArray(name) ? name.map(filter ?? escapeSpecialSymbols) : void 0) ?? ('object' == typeof name ? [] : [
        name
    ]);
    const reduceName = eventName.reduce((current, item, index)=>{
        if ('number' == typeof item) {
            const target = 0 === index ? '' : current[index - 1];
            current.splice(Math.max(index - 1, 0), 1, `${target}[${item}]`);
            return current;
        }
        return current.concat(item);
    }, []);
    try {
        const targetName = `${defaultName}${reduceName.join('.')}`;
        Path.parse(targetName);
        return cacheEventName(name, targetName) ?? defaultName;
    } catch  {
        return cacheEventName(name, defaultName) ?? defaultName;
    }
};
const isResultType = (data)=>'object' == typeof data && null !== data && 'success' in data && !data.success;
function mountEvent(event) {
    const { rule } = event.detail ?? {};
    if (event.detail && rule) eventBus.emit(event.detail);
}
export { EventName, combinePath, createEvent, createToken, defaultLang, getConditionKey, getEventName, isResultType, mountEvent };
